/**
 * For a duration of video/audio files input is number like 1.23 (1 seconds and 230 milliseconds),
 * the output is in the format of 00:00
 *
 * @param {number} value
 * @returns {string}
 */
export function videoDuration(value) {
  if (typeof value !== 'number' || isNaN(value)) {
    throw 'videoDuration parameter must be a number of seconds';
  }

  let sign = '';
  if (value < 0) {
    sign = '-';
    value = Math.abs(value);
  }

  let floorValue = Math.floor(value);
  // value = parseFloat(value);

  let seconds = floorValue % 60;
  let minutes = Math.floor(floorValue / 60);

  return  sign +
    (minutes < 10 ? "0"  : "") + minutes +
    (seconds < 10 ? ":0" : ":") + seconds;
}

/**
 * Input is a number like 1.23 (1 seconds and 230 milliseconds)
 * Output is in the format of 00:00.24  (the last one is the frame)
 *
 * @param {string|number} value
 * @param {number} [framerate=24]
 * @returns {*}
 */
export function toTimeFrames(value, framerate = 24) {
  const calculatedFramerate = 1000 / framerate;
  const floorValue = Math.floor(value);
  value = parseFloat(value);

  const timeStr = videoDuration(value);
  const ms = value - floorValue;
  const frames = ((ms * 1000) / calculatedFramerate).toFixed(0);
  return timeStr + (frames  < 10 ? "f0" : "f") + frames;
}

/**
 * Input is number like 1.23 (1 seconds and 230 milliseconds)
 * Output is in the format of 00:01.23 (the last one is milliseconds)
 *
 * @param {number} value
 * @returns {string}
 */
export function toTimeMilliseconds(value) {
  if (typeof value !== 'number' || isNaN(value)) {
    throw 'toTimeMilliseconds parameter must be a number of seconds';
  }

  const timeStr = videoDuration(value);
  const millisec = value - Math.floor(value);
  let millisecInt = Math.floor(millisec * 100);

  // A problem with rounding of floats
  if (millisecInt >= 100) {
    millisecInt = 0;
  }

  return timeStr + (millisecInt < 10 ? '.0' : '.') + millisecInt;
}

/**
 * Input is number like 1.234 (1 seconds and 234 milliseconds).
 * Output is in the format of 00:01.234 (the last one is milliseconds)
 *
 * @param {number} value
 * @returns {string}
 */
export function toTimeMillisecondsFull(value) {
  if (typeof value !== 'number' || isNaN(value)) {
    throw "toTimeMilliseconds parameter must be a number of seconds";
  }

  const timeStr = videoDuration(value);
  const millisec = value - Math.floor(value);
  let millisecInt = Math.floor(millisec * 1000);

  // A problem with rounding of floats
  if (millisecInt >= 1000) {
    millisecInt = 0;
  }

  if (millisecInt < 100 && millisecInt >= 10) {
    return timeStr + ".0" + millisecInt;
  } else if (millisecInt < 10) {
    return timeStr + ".00" + millisecInt;
  }

  return timeStr + "." + millisecInt;
}
